import React from 'react';
import { Button } from '../components/Button';
export function NotFound() {
  return <section className="mx-auto flex min-h-[70vh] max-w-xl flex-col items-center justify-center px-6 pt-32 text-center" data-id="element-418" data-mp="w3zwjvurcc1p">
      <p className="font-script text-2xl italic text-ink-muted" data-id="element-419" data-mp="104tg6d1634os">Wrong turn on the Strip</p>
      <h1 className="mt-3 font-slab text-5xl font-bold uppercase tracking-[0.12em]" data-id="element-420" data-mp="1557pdyei8koe">Page Not Found</h1>
      <p className="mt-5 leading-relaxed text-ink-muted" data-id="element-421" data-mp="1a4u123eopsv3">The page you’re looking for doesn’t exist or has moved.</p>
      <Button to="/" className="mt-8" data-id="element-422" data-mp="1f1u9gkz0b7pd">
        Back to home
      </Button>
    </section>;
}